import { useEffect, useState } from 'react';
import { LayoutDashboard, FileText, FolderOpen, CreditCard, User, Bell, MessageSquare, Users, CalendarDays, FileSignature, PenLine, Building2, HardDrive, BookOpen } from 'lucide-react';
import { useAuthStore } from '@/stores/auth.store';
import { api } from '@/lib/api';
import WorkspaceShell from './WorkspaceShell';

type NavItem = { to: string; icon: React.ElementType; label: string; badge?: boolean };

const BASE_NAV: NavItem[] = [
  { to: '/app/client/dashboard',     icon: LayoutDashboard, label: 'Tableau de bord' },
  { to: '/app/client/missions',         icon: FileText,    label: 'Mes missions' },
  { to: '/app/client/creation-societe', icon: Building2,   label: "Création d'entreprise" },
  { to: '/app/client/calendar',         icon: CalendarDays, label: 'Calendrier' },
  { to: '/app/client/messages',      icon: MessageSquare,   label: 'Messagerie' },
  { to: '/app/client/documents',     icon: FolderOpen,       label: 'Documents' },
  { to: '/app/client/drive',        icon: HardDrive,        label: 'VaegDrive' },
  { to: '/app/client/templates',     icon: PenLine,          label: 'Documents à remplir' },
  { to: '/app/client/signatures',    icon: FileSignature,    label: 'Signatures', badge: false },
  { to: '/app/client/subscription',  icon: CreditCard,      label: 'Abonnement' },
  { to: '/app/client/profile',       icon: User,            label: 'Profil' },
  { to: '/app/client/aide',          icon: BookOpen,        label: 'Mode d\'emploi' },
  { to: '/app/client/notifications', icon: Bell,            label: 'Notifications', badge: true },
];

const TEAM_NAV: NavItem = { to: '/app/client/team', icon: Users, label: 'Mon équipe' };

export default function ClientLayout() {
  const { user } = useAuthStore();
  const [isCompanyAdmin, setIsCompanyAdmin] = useState(false);
  useEffect(() => {
    let active = true;
    setIsCompanyAdmin(false);
    if (user) api.get('/client-members').then(r => {
      const me = r.data.data?.members?.find((m: { user: { id: string }; role: string }) => m.user.id === user.id);
      if (active) setIsCompanyAdmin(me?.role === 'ADMIN');
    }).catch(() => {});
    return () => { active = false; };
  }, [user?.id]);
  const items = isCompanyAdmin ? [...BASE_NAV.slice(0, 4), TEAM_NAV, ...BASE_NAV.slice(4)] : BASE_NAV;
  return <WorkspaceShell title="Espace client" items={items} quickPaths={['dashboard', 'missions', 'messages', 'documents']} />;
}
